import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';

import Input from '../../elements/Input/Input';
import Button from '../../elements/Button/Button';
import ModalContainer from '../../elements/ModalContainer/ModalContainer';
import { setLoading } from '../../redux/loading/loadingActions';
import Routes from '../../components/Routes';
import { showError } from '../../elements/Toasts/toastActions';
import modal from '../../elements/ModalContainer/ModalContainer.module.scss';
import { ReactComponent as DeletIcon } from '../../styles/icon/delete.svg';
import strings from '../../lang/lang';
import { useAppSelector, useAppDispatch } from '../../hooks/useRedux';
import { appsActions, appDetailsData, deleteAppModalState } from '../../redux/reducers/apps';

function DeleteAppModal(props) {
  const [appName, setName] = useState('');
  const { history } = props;
  const dispatch = useAppDispatch();
  const isVisibleDeleteAppModal = useAppSelector(deleteAppModalState);
  const appData = useAppSelector(appDetailsData);
  const { id: appId, name } = appData;

  function deleteSelectedApp() {
    setLoading(true, true);
    return new Promise((res, rej) => {
      dispatch(appsActions.deleteApp({ appId, res, rej }));
    })
    .then(() => {
      history.push(Routes.routes.APPLIST.path);
    })
    .catch(() => {
      showError(strings.appUtils.errors.deletingApp);
    })
    .finally(() => {
      setLoading(false);
      dispatch(appsActions.toogleDeleteAppModal(false));
    });
  }

  return (
    <ModalContainer
      isOpen={isVisibleDeleteAppModal}
      closeModalWindow={() => dispatch(appsActions.toogleDeleteAppModal(false))}
      title={strings.appUtils.text.modelDeleteAppTitle}
      header={strings.appUtils.text.modelDeleteAppDescription}
    >
      <Input
        id="appName"
        name="appName"
        label={strings.appUtils.fields.appName}
        autoComplete="off"
        autoFocus="autofocus"
        value={appName}
        onChange={(e) => setName(e.target.value)}
      />
      <div className={modal['react-modal__btn-box']}>
        <Button
          name={strings.appUtils.buttons.delete}
          variant="delete"
          secondaryClassName="popup_secondary"
          type="submit"
          onClick={() => deleteSelectedApp()}
          disabled={appName !== name}
        >
          <DeletIcon />
        </Button>
      </div>
      <Button
        name={strings.appUtils.buttons.cancel}
        variant="secondary"
        secondaryClassName="popup_secondary"
        type="submit"
        onClick={() => dispatch(appsActions.toogleDeleteAppModal(false))}
      />
    </ModalContainer>
  );
}

export default withRouter(DeleteAppModal);
